import {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {selectEventId} from '~/common/fabric/EventGuests/reducers/guests/selectors';
import {isFabricWebview} from '~/common/utils/webview';
import {ContentIdentifiers} from '~library/shared/enums/ContentIdentifiers';
import {TrackingEvents} from '~library/shared/enums/TrackingEvents';
import {sendTrackingData} from '~library/utils/tracking';
import {EventGifting} from './EventGifting';
import {EventGifting as EventGiftingAppOnly} from './EventGiftingAppOnly';

type EventGiftingVariantProps = {
  inPreviewStep?: boolean;
  disableTracking: boolean;
};

export const EventGiftingWrapper = ({
  inPreviewStep = false,
  disableTracking,
}: EventGiftingVariantProps) => {
  const isWebview = isFabricWebview();
  const eventId = useSelector(selectEventId);

  useEffect(() => {
    if (!disableTracking) {
      sendTrackingData(TrackingEvents.ContentLoadTracking, {
        identifier: ContentIdentifiers.CreateEditInvitationEventGifting,
        attributes: {eventId},
      });
    }
  }, [disableTracking, eventId]);

  if (isWebview) {
    return <EventGiftingAppOnly inPreviewStep={inPreviewStep} />;
  }

  return <EventGifting inPreviewStep={inPreviewStep} />;
};
